import { useQuery, UseQueryResult } from "react-query";
import { PipelineImportData, QueryFilter } from "./types";
import { get } from "./api";

export default function useGetPipelineImportRows(
  importId: string,
  filter: QueryFilter,
  limit: number,
  offset: number
): UseQueryResult<PipelineImportData> {
  return useQuery<PipelineImportData, unknown>(["pipeline-import-rows", importId, filter, limit, offset], () =>
    fetchRows(importId, filter, limit, offset)
  );
}

export async function fetchRows(importId: string, filter: QueryFilter, limit: number, offset: number): Promise<PipelineImportData> {
  const response = await get(`pipeline-import/${importId}/rows?filter=${filter}&limit=${limit}&offset=${offset}`);

  if (!response.ok) throw response.error;

  return response.data;
}
